export const pricing = {
  hero: {
    heading: {
      serve: 'Serve',
      more_orders: 'more orders',
      to_your_restaurant: 'to your restaurant with Bistroo',
    },
    saving_time: 'We\'re saving time and increase your profit.',
    boosting_business: 'We\'re boosting your online business.',
  },

  plans: {
    free: {
      title: 'Free',
      price: '€ 0',
      period: 'Lifetime',
      subtitle: 'Webshop variable',
      description: 'For business owners who are looking for more orders',
      enabledFeatures: [
        'Webshop',
        'Order management',
        'Sales insights',
        'Menu builder',
        'Product configurator',
        'Discounts & promo',
        'Basic reporting',
      ],
    },
    starter: {
      title: 'Starter',
      price: '€ 39',
      period: '/ month',
      subtitle: 'Webshop or QR fixed',
      description: 'For starters that want to grow their business and have a fixed fee',
      enabledFeatures: [
        'Webshop or QR order',
        'Order management',
        'Sales insights',
        'Menu builder',
        'Product configurator',
        'Discounts & promo',
        'Basic reporting',
        'Integrations (POS etc.)',
        'Printer support'
      ],
    },
    professional: {
      title: 'Professional',
      price: '€ 49',
      period: '/ month',
      subtitle: 'Webshop and website',
      description: 'For restaurants that want the full package deal to grow pro',
      enabledFeatures: [
        'Webshop',
        'Website',
        'Custom brand styling',
        'Order management',
        'Sales insights',
        'Menu builder',
        'Product configurator',
        'Discounts & promo',
        'Advanced reporting',
        'QR ordering module',
        'Integrations (POS etc.)',
        'Printer support'
      ],
    },
    enterprise: {
      title: 'Enterprise',
      price: 'Custom',
      period: 'pricing',
      subtitle: 'Build your package',
      description: 'For bigger clients who want to customize our services to their needs',
      enabledFeatures: [
        'Custom webshop',
        'Custom website',
        'Custom brand styling',
        'Full premium options',
        'Team & user management',
        'Order management',
        'Sales insights',
        'Menu builder',
        'Product configurator',
        'Discounts & Promo\'s',
        'Advanced reporting',
        'QR ordering module',
        'Integrations (POS etc.)',
        'Printer support',
      ],
    }
  },

  compare: 'Compare all features below',

  closer_look: {
    title: 'A closer look to each plan',
    description: {
      1: 'Whether you\'re just getting started or scaling fast, we\'ve got features to support your success.',
      2: 'Explore our flexible SaaS packages designed to grow with your needs.'
    }
  },

  table: {
    row_1: {
      title: 'Base package',
      value_1: 'Webshop',
      value_2: 'Webshop or QR',
      value_3: 'Website & webshop or QR',
      value_4: 'Website, webshop & QR'
    }
  }
}